import { render } from "./Dropdown.vue?vue&type=template&id=afe38a64"
import script from "./Dropdown.vue?vue&type=script&lang=js"
export * from "./Dropdown.vue?vue&type=script&lang=js"
script.render = render

export default script